import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FieldValue } from '@vendasta/crm';
import { FieldValueInterface } from '../../../tokens-and-interfaces';

@Injectable({ providedIn: 'root' })
export class UpdaterService {
  updatedField: BehaviorSubject<FieldValueInterface>;

  constructor() {
    this.updatedField = new BehaviorSubject<FieldValueInterface>(new FieldValue());
  }

  updateStringField(fieldId: string, value: string) {
    this.updatedField.next(new FieldValue({ fieldId: fieldId, stringValue: value }));
  }

  updateGeopointField(fieldId: string, lat: number, lon: number) {
    this.updatedField.next(new FieldValue({ fieldId: fieldId, geopointValue: { lat: lat, lon: lon } }));
  }
}
